import { useState } from 'react';

import { useAppSelector } from 'features/app/hooks';
import type { DialedNumbersList } from 'features/dialed-numbers-history/interfaces';
import { dialedNumbersListSelector } from 'features/dialed-numbers-history/store';
import { maskPhoneNumber } from 'features/phone-number/helpers';

export const useDialedNumbersHistory = () => {
  const [isOpenHistory, setIsOpenHistory] = useState(false);
  const unMaskedDialedNumbersList = useAppSelector(dialedNumbersListSelector);

  const dialedNumbersList: DialedNumbersList =
    unMaskedDialedNumbersList.map(maskPhoneNumber);

  return {
    isOpenHistory,
    setIsOpenHistory,
    dialedNumbersList,
  };
};
